export const environment = {
  production: false,
  deepLinksApiUrl: 'https://deeplinkapi-dev.azurewebsites.net',
  nevoAIButlerAPIEndpoint: "https://nevoaibutlerapi-dev.azurewebsites.net",
  oauthServerUrl: 'https://oauthserver-dev.azurewebsites.net',
  oauthWebApi: 'https://oauthwebapi-dev.azurewebsites.net',
  clientId: '3a35e731d9954fc1a8c9f85bc5080727',
  username: 'NevoCloudAdmin',
  password: 'Agilepw@1',
  appInsights: {
    instrumentationKey: '84b630e7-b20e-42ee-b70a-a6855e736b0a'
  }
};